import { CM_PER_IN, GRAMS_IN_KG, KG_PER_LB, MM_IN_CM, MM_IN_M } from '@/constants/unit.constants';

export const roundToDecimal = (value: number, decimalPlaces = 2): number => parseFloat(value.toFixed(decimalPlaces));

export const gramsToKg = (grams: number, decimalPlaces?: number): number => {
  const value = grams / GRAMS_IN_KG;
  return decimalPlaces === undefined ? value : roundToDecimal(value, decimalPlaces);
};

export const kgToGrams = (kg: number, decimalPlaces?: number): number => {
  const value = kg * GRAMS_IN_KG;
  return decimalPlaces === undefined ? value : roundToDecimal(value, decimalPlaces);
};

export const mmToCm = (mm: number, decimalPlaces?: number): number => {
  const value = mm / MM_IN_CM;
  return decimalPlaces === undefined ? value : roundToDecimal(value, decimalPlaces);
};

export const cmToMm = (cm: number, decimalPlaces?: number): number => {
  const value = cm * MM_IN_CM;
  return decimalPlaces === undefined ? value : roundToDecimal(value, decimalPlaces);
};

export const kgToLb = (kg: number, decimalPlaces?: number): number => {
  const value = kg / KG_PER_LB;
  return decimalPlaces === undefined ? value : roundToDecimal(value, decimalPlaces);
};

export const lbToKg = (lb: number, decimalPlaces?: number): number => {
  const value = lb * KG_PER_LB;
  return decimalPlaces === undefined ? value : roundToDecimal(value, decimalPlaces);
};

export const cmToIn = (cm: number, decimalPlaces?: number): number => {
  const value = cm / CM_PER_IN;
  return decimalPlaces === undefined ? value : roundToDecimal(value, decimalPlaces);
};

export const inToCm = (inches: number, decimalPlaces?: number): number => {
  const value = inches * CM_PER_IN;
  return decimalPlaces === undefined ? value : roundToDecimal(value, decimalPlaces);
};

export const inToFtIn = (inches: number, decimalPlaces?: number): { ft: number; in: number } => {
  const ft = Math.floor(inches / 12);
  const remainingIn = inches % 12;
  const roundedIn = decimalPlaces === undefined ? remainingIn : roundToDecimal(remainingIn, decimalPlaces);
  return { ft, in: roundedIn };
};

export const ftInToIn = (ft: number, inches: number, decimalPlaces?: number): number => {
  const value = ft * 12 + inches;
  return decimalPlaces === undefined ? value : roundToDecimal(value, decimalPlaces);
};

export const calcBmi = (weightGrams: number, heightMm: number, decimalPlaces = 1) => {
  const kg = weightGrams / GRAMS_IN_KG;
  const m = heightMm / MM_IN_M;
  return roundToDecimal(kg / (m * m), decimalPlaces);
};
